module.exports = __webpack_public_path__ + "img/Myanmar.eed22efd.gif";